import { render } from "./HiViewSuccessful.vue?vue&type=template&id=40c1be06"
import script from "./HiViewSuccessful.vue?vue&type=script&lang=js"
export * from "./HiViewSuccessful.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__